import { Link } from 'react-router-dom';

const guides = [
  {
    slug: 'hipobuy-spreadsheet-guide',
    title: 'Hipobuy Spreadsheet Guide',
    desc: 'The ultimate resource covering category navigation, platform comparisons, safety practices, and expert shopping strategies.',
    label: 'Complete Guide',
    color: 'primary',
  },
  {
    slug: 'kakobuy-spreadsheet-guide',
    title: 'Kakobuy Spreadsheet Guide',
    desc: 'Deep dive into fashion and streetwear curation with community-driven trend discovery.',
    label: 'Fashion Focus',
    color: 'accent',
  },
  {
    slug: 'cssbuy-spreadsheet-guide',
    title: 'CSSBuy Spreadsheet Guide',
    desc: 'Community-powered platform with extensive reviews, QC reports, and collaborative research tools.',
    label: 'Community Pick',
    color: 'secondary',
  },
  {
    slug: 'superbuy-spreadsheet-guide',
    title: 'Superbuy Spreadsheet Guide',
    desc: 'International logistics specialist with real-time shipping estimates and customs guidance.',
    label: 'Global Shipping',
    color: 'primary',
  },
  {
    slug: 'oopbuy-spreadsheet-guide',
    title: 'Oopbuy Spreadsheet Guide',
    desc: 'Value-focused platform with proprietary price-scoring for budget-conscious shoppers.',
    label: 'Best Value',
    color: 'accent',
  },
];

const colorMap: Record<string, { bg: string; text: string; badge: string; badgeText: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-700', badge: 'bg-primary-100', badgeText: 'text-primary-600' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-700', badge: 'bg-accent-100', badgeText: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', badge: 'bg-secondary-100', badgeText: 'text-secondary-600' },
};

export default function ArticlePreview() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-label tracking-widest uppercase text-primary-600 mb-3">
            / SEO Guides & Resources
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Spreadsheet Platform Guides
          </h2>
          <p className="text-base text-foreground-600 mt-4 max-w-2xl mx-auto">
            In-depth guides covering all major spreadsheet shopping platforms. Each guide features original content, platform comparisons, safety tips, and expert strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {guides.map((guide) => {
            const c = colorMap[guide.color];
            return (
              <Link
                key={guide.slug}
                to={`/${guide.slug}`}
                className={`group block ${c.bg} border border-background-200/60 rounded-lg p-6 md:p-7 hover:border-primary-300 transition-all duration-300`}
              >
                <span className={`inline-block px-3 py-1 rounded-full text-[11px] font-label font-semibold tracking-wide uppercase mb-4 ${c.badge} ${c.badgeText}`}>
                  {guide.label}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {guide.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {guide.desc}
                </p>
                <div className="flex items-center gap-1 text-xs font-medium text-primary-500">
                  <span>Read Guide</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-foreground-800 transition-all"
          >
            <i className="ri-book-open-line"></i>
            Start with Hipobuy Spreadsheet Guide
          </Link>
        </div>
      </div>
    </section>
  );
}